const pluck = name => item => item[name]

const id = pluck('id')
const type = pluck('type')
const value = pluck('value')
const attributes = pluck('attributes')
const partNumber = pluck('partNumber')
const citrusId = pluck('citrusId')

const project = {
  id,
  type,
  value,
  attributes,
  partNumber,
  citrusId
}

export default project
